import React from "react";
import { StaticQuery, graphql } from "gatsby"
import { Location } from '@reach/router'
import {InlineShareButtons} from 'sharethis-reactjs';

export default () => (
  <StaticQuery
    query={graphql`
      query ShareQuery {
        site {
          siteMetadata {
            siteUrl: url
          }
        }
      }
    `}
    render={({
        site: {
          siteMetadata: {
            siteUrl
          },
        },
      }) => {
          return (
            <Location>
                {({ location }) => {
                    return (
                        <div style={{paddingTop:15}}>
                        <InlineShareButtons
                            config={{
                                id:'sharethis-inlinebuttons',
                                alignment: 'justified',
                                color: 'social',
                                enabled: true,
                                labels: 'null',
                                language: 'it',
                                networks: [
                                    'whatsapp',
                                    'facebook',
                                    'messenger',
                                    'twitter',
                                    'email',
                                    'sms'
                                ],
                                padding: 4,
                                radius: 4,
                                size: 35,
                                url: siteUrl+location.pathname,
                                message: 'Ciao, quando hai tempo, leggi questo articolo... potrebbe interessarti!\n\n'+siteUrl+location.pathname,
                                subject: 'Quando hai tempo, leggi questo articolo...',
                            }}
                        />
                        </div>
                    )
                }}
            </Location>
          )
      }}
  />
)